import React from "react";

const Presentacion: React.FC = () => {
  return (
    <section id="about" className="mb-10">
      <h2 className="text-2xl font-bold mb-2 text-dark">Sobre mí</h2>
      <p className="text-dark opacity-70 text-sm leading-relaxed">
        Apasionado por todo lo que hago, siempre dispuesto a enfrentar desafíos.
        Diseñador y desarrollador de sitios y aplicaciones web que impulsan el
        éxito de cada proyecto.
      </p>
    </section>
  );
};

export default Presentacion;
